// src/components/AnhCoKhoa.js
import React, { useEffect, useState } from "react";
import { layBlob } from "../services/api";

// ============================================================
// 🔒 ẢNH CẦN ĐĂNG NHẬP MỚI XEM (Đợt N5, 14/09/2026)
// ------------------------------------------------------------
// Lấy ảnh bằng fetch kèm thẻ đăng nhập, rồi vẽ từ bộ nhớ trình duyệt
// (xem khối 📷 trong services/api.js vì sao không dùng <img src> thẳng).
//
// Ba trạng thái, không trạng thái nào là "ảnh vỡ":
//   • đang tải   → ô xám "⏳"
//   • đã cất đi  → "🗂️ ảnh đã cất" (máy chủ trả 410 — anh chốt câu 4)
//   • lỗi khác   → "⚠️ không mở được ảnh"
// ============================================================
function AnhCoKhoa({ anhId, moTa, className, style, onClick }) {
  const [url, setUrl] = useState(null);
  const [tinhTrang, setTinhTrang] = useState("dang-tai");

  useEffect(() => {
    let conDung = true;
    let urlTam = null;
    setTinhTrang("dang-tai");
    layBlob(`anh/${anhId}`)
      .then(({ blob }) => {
        if (!conDung) return;
        urlTam = URL.createObjectURL(blob);
        setUrl(urlTam);
        setTinhTrang("xong");
      })
      .catch((err) => {
        if (conDung) setTinhTrang(err.status === 410 ? "da-cat" : "loi");
      });
    return () => {
      conDung = false;
      // Trả lại bộ nhớ khi rời trang — mỗi tấm ảnh giữ vài trăm KB.
      if (urlTam) URL.revokeObjectURL(urlTam);
    };
  }, [anhId]);

  if (tinhTrang === "da-cat") return <span className="anh-da-cat">🗂️ ảnh đã cất</span>;
  if (tinhTrang === "loi") return <span className="anh-loi">⚠️ không mở được ảnh</span>;
  if (tinhTrang === "dang-tai") {
    return <span className={`anh-dang-tai ${className || ""}`} style={style}>⏳</span>;
  }
  return (
    <img
      src={url}
      alt={moTa || "Ảnh"}
      className={className}
      style={style}
      onClick={onClick}
    />
  );
}

export default AnhCoKhoa;
